import React from 'react';
import { withLoading } from '@front-activerse/common-components';
import TrackerAddMeal from '../components/TrackerAddMeal';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import { normalizeDescribeMeal } from '../helpers/normalizers';
import { DescribeMealProps } from '../types';

const TrackerAddDescribeMealContainer: React.FC<DescribeMealProps> = (props) => {
  const normalizedProps = normalizeDescribeMeal(props);

  return (
    <TrackerAddMeal
      key={normalizedProps.mealData.name}
      {...normalizedProps}
      mode="forward-navigation"
    />
  );
};

export default withLoading(TrackerAddDescribeMealContainer, UniversalPlaceholder);
